const getNcbiDbnsfpSchemaProperties = (state) =>
  state.schema && state.schema.properties && state.schema.properties.ncbi_dbsnp;

const getNcbiDbnsfpData = (state) =>
  state.variantResult && state.variantResult.ncbi_dbsnp;

const getVarsomeQueries = (state) =>
  state && state.variantResult && state.variantResult.varsome_queries;

const getVcfRsIds = (state) =>
  state && state.variantResult && state.variantResult.vcfRsIds;

export {
  getNcbiDbnsfpSchemaProperties,
  getNcbiDbnsfpData,
  getVarsomeQueries,
  getVcfRsIds,
};
